import * as St from './Logo.styles';

const Logo = (): JSX.Element => (
  <St.Container>
    <img
      src="/public/assets/images/Header/eeWhiteLogoFull.svg"
      alt="Logo"
      height={130}
      width={130}
    />
  </St.Container>
);

export default Logo;
